import { EmailController } from "@/app/core/base/controllers/EmailController";
import Field from "@/app/core/layouts/main-components/input/Field";
import { OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { Message } from "@/app/core/util/messages/GeralMessages";
import React, { useState } from "react";
import { toast } from "react-toastify";

export default function SobreComponent(props) {
    const [data, setData] = useState({});

    function handleChange(evt){
        setData(OnDataChange(data, evt))
    }

    async function sendEmail(){
        if(!data.name ||
        !data.email ||
        !data.phone ||
        !data.subject ||
        !data.message){
            toast.error(Message.PendingData);
        }else{
            await EmailController.SendContactRequest(data);
            toast.success("Mensagem enviada com sucesso, em breve entraremos em contato");
        }
    }

    return (
        <div className="content">
            <div className="row no-gutters justify-content-center mt-5 mb-10 ml-5 mr-5">
                <div className="col-md-8 block block-rounded block-bordered mb-5 mt-5">
                    <div className="block-content">
                        <h4 className="text-center">Entre contato conosco através de nosso formulário de mensagens e deixe sua dúvida, sugestão ou reclamação</h4>
                        <div className="row">
                            <div className="col-md-12">
                                <Field type={FieldTypeObj.Text} title={"Nome"} name={"name"} value={data && data.name} onChange={evt => handleChange(evt)}/>
                            </div>
                            <div className="col-md-12">
                                <Field type={FieldTypeObj.Text} title={"E-mail"} name={"email"} value={data && data.email} onChange={evt => handleChange(evt)}/>
                            </div>
                            <div className="col-md-12">
                                <Field type={FieldTypeObj.Mask} title={"Telefone"} mask={"(99) 9999-99999"} name={"phone"} value={data && data.phone} onChange={evt => handleChange(evt)}/>
                            </div>
                            <div className="col-md-12">
                                <Field type={FieldTypeObj.Text} title={"Assunto"} name={"subject"} value={data && data.subject} onChange={evt => handleChange(evt)}/>
                            </div>
                            <div className="col-md-12">
                                <Field type={FieldTypeObj.TextArea} title={"Escreva aqui a sua mensagem"} name={"message"} value={data && data.message} onChange={evt => handleChange(evt)}/>
                            </div>
                            <div className="col-md-12 text-center">
                                <button className="btn btn-hero-warning text-dark" onClick={()=>sendEmail()}>Enviar</button>
                            </div>
                        </div>
                        <a className="btn btn-dark mb-3" href="#/"><i className="fa fa-arrow-left"/> Voltar</a>
                    </div>
                </div>
            </div>
        </div>
    )
}